import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import getKhattabatSelectsStore from "./selects-store";
import getCorePopUpStore from "../core/core-popup-store";
import getKhattabatStore from ".";
import { apiSendOneOOneMultipleMsgs } from "../../api/khattbat-api/send-one-o-one-multiple-msgs";
import { TSelectionPages } from "../../Types";
import { getKhattabatResultsStore } from "./results-store";

class KhattabatAiMessagesStore {
  isOpenedAiMesssagesBox = observable.box<boolean>(false);
  fieldsInput = observable.map<number, string>([]);
  isSendingMessages = observable.box<boolean>(false);

  setIsSendingMessages = (state: boolean) => {
    runInAction(() => {
      this.isSendingMessages.set(state);
    });
  };

  setIsOpenedAIMessagesBox = (state: boolean) => {
    runInAction(() => {
      this.isOpenedAiMesssagesBox.set(state);
    });
  };

  setFieldInput = ({ index, text }: { text: string; index: number }) => {
    runInAction(() => {
      this.fieldsInput.set(index, text);
    });
  };

  initializeInputFields = () => {
    for (let index = 0; index < 10; index++) {
      this.setFieldInput({ index, text: "" });
    }
  };

  toggleIsOpenedBox = () => {
    const currentState = this.isOpenedAiMesssagesBox.get();
    this.setIsOpenedAIMessagesBox(!currentState);
  };

  shouldSendMessages = computed(() => {
    const hasDefinedField = Array.from(this.fieldsInput.values()).some(
      (text) => {
        return isDefinedString(text);
      }
    );
    return hasDefinedField && !this.isSendingMessages.get();
  });

  getConversationMessages = () => {
    let conversationMessages: string[] = [];
    Array.from(this.fieldsInput.values()).forEach((text) => {
      if (isDefinedString(text)) {
        conversationMessages.push(text);
      }
    });
    return conversationMessages;
  };

  sendAllMessages = async (pageType: TSelectionPages) => {
    const currentMarkeduserId = getKhattabatSelectsStore().getMarkedUserIds();
    const noChosenUsers = !isPositiveNumber(currentMarkeduserId.length);
    if (noChosenUsers) {
      return getCorePopUpStore().showAlertMessage("PLEASE_AT_LEAST_ONE_USER");
    }
    const isMatchingPage = pageType === "matchResultPage";

    const conversationParticipants = isMatchingPage
      ? getKhattabatResultsStore().getBasicMatchInformation(currentMarkeduserId)
      : currentMarkeduserId.map((userID) => {
          const { alkhattabaUUID, userUUID } =
            getKhattabatStore().getClientInformationsAndIndex({
              userID
            }).userData;
          return {
            alkhattabaUUID,
            userUUID,
            userID
          };
        });
    const conversationMessages = this.getConversationMessages();
    this.setIsSendingMessages(true);
    const { status, code } = await apiSendOneOOneMultipleMsgs({
      conversationParticipants,
      conversationMessages,
      conversationType: pageType === "matchResultPage" ? "101M" : "101C"
    });
    this.setIsSendingMessages(false);
    if (status === "OK") {
      this.initializeInputFields();
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

export const getKhattabatAiMessagesStore = memoize(
  () => {
    return new KhattabatAiMessagesStore();
  },
  () => 1
);

export default getKhattabatAiMessagesStore;
